import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild, ChangeDetectorRef, inject, DestroyRef} from '@angular/core';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { Configuration } from 'src/app/models/configurations/configuration';
import { Constants } from 'src/app/models/constants';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ConfigurationApplicationStatus}
  from 'src/app/models/configurations/configuration-state';

@Component({
    selector: 'app-request-update-configuration',
    templateUrl: './request-update-configuration.component.html',
    styleUrls: ['./request-update-configuration.component.scss'],
    standalone: false
})
export class RequestUpdateConfigurationComponent implements OnInit {
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;

  @Input() title: string;
  @Input() subtitle: string;
  @Input() instance: any;
  @Input() set availableConfigurations(availableConfigurations: Configuration[]) {
    this.configurations = availableConfigurations !== undefined ? [...availableConfigurations] : [];
    this.configurations.sort(this.defaultComparator);
  }
  ConfigurationApplicationStatus = ConfigurationApplicationStatus;
  configurations: Configuration[];
  pageConfigurations: Configuration[];
  filteredConfigurations: Configuration[];
  expandedRows: KeyValueMap<string, boolean> = {};
  updateData: boolean;

  selection: Configuration;
  Constants = Constants;
  private destroyRef = inject(DestroyRef);

  constructor(public sidenavService: SidenavService, public datepipe: DatePipe, private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.paginator.page
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(pageEvent => {
      const startIndex = pageEvent.pageIndex * pageEvent.pageSize;
      this.pageConfigurations = this.filteredConfigurations.slice(startIndex, startIndex + pageEvent.pageSize);
      this.pageConfigurations.filter((item) => {
        const patchValue = parseInt(item.manifest.version.split('.').pop());
        if(patchValue > 0) {
          item.hotfix = true;
        }
      });

      if (!this.pageConfigurations.includes(this.selection)) {
        this.selection = null;
      }
      this.changeDetectorRef.detectChanges();
    });
    this.search();

    if (this.instance?.configurationStates) {
      if (this.instance?.configurationStates[0]?.status === ConfigurationApplicationStatus.VERIFIED) {
        this.updateData = true;
        this.selection = null;
      }
    }
  }

  expandRow(configuration: Configuration): void {
     this.expandedRows[configuration.id] = !this.expandedRows[configuration.id];
  }

  /**
   * Performs a simple search in the list of configurations
   *
   * @param value Method that filters displayed configurations based on search criteria.
   */
  search(value?: string): void {
    if(value) {
      const searchValue = value.toLowerCase();
      this.filteredConfigurations = this.configurations.filter(config =>
        config.manifest.name.toLowerCase().includes(searchValue) ||
        config.manifest.version.toLowerCase().includes(searchValue));
    } else {
      this.filteredConfigurations = this.configurations;
    }

    // Clear selection when page is changed
    if (this.selection && !this.filteredConfigurations.includes(this.selection)) {
      this.selection = null;
    }

    // If there is only one configuration select it by default
    if (this.filteredConfigurations.length === 1) {
      this.selection = this.filteredConfigurations[0];
    }

    this.paginator.length = this.filteredConfigurations.length;
  }

  /**
   * Changes the selection each time we click on a row
   *
   * @param row - the selected row
   */
  select(row): void {
    this.selection = row;
  }

  /**
   * Applies the selected configuration
   */
  verifyConfiguration(): void {
    const selectedConfiguration = this.selection;
    this.sidenavService.closeRightSidenav(selectedConfiguration);
  }

  applyConfiguration(): void {
    const selectedConfiguration = this.instance;
    this.sidenavService.closeRightSidenav(selectedConfiguration);
  }

  private defaultComparator(config1: Configuration, config2: Configuration): number {
    if (config1?.manifest?.dataGenerated && config2?.manifest?.dataGenerated) {
      return new Date(config2.manifest.dataGenerated).getTime() - new Date(config1.manifest.dataGenerated).getTime();
    }
    return 0;
  }
}
